import Services from '../components/homePage/Services';
import Approach from '../components/homePage/Approach';
import Impact from '../components/homePage/Impact';
import Programs from '../components/homePage/Programs';
import Testimonial from '../components/homePage/Testimonials';
import Cta from '../components/homePage/Cta';
import LandingPage from '../components/homePage/LandingPage';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

const Home = () => {

  return (
    <div className="min-h-screen bg-black text-white font-light">
      <Helmet>
        <title>AI Training & Enterprise AI Consulting | Frost & Grey</title>

        <meta
          name="description"
          content="Frost & Grey provides AI training, enterprise AI consulting, and workforce upskilling across Africa. Empower your team with practical AI skills, workflow automation, and responsible AI adoption for measurable business impact."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://frostandgrey.com" />

        {/* Open Graph */}
        <meta property="og:title" content="Frost & Grey — AI Training & Enterprise AI Consulting" />
        <meta
          property="og:description"
          content="Practical AI training, automation workflows, and AI consulting for teams and organizations across Africa. Build capability, improve productivity, and scale with AI."
        />
        <meta property="og:url" content="https://frostandgrey.com" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 overflow-hidden hidden md:block md:w-1/2 lg:w-[45%]">
        <motion.img
          src="https://res.cloudinary.com/dhdyo9wwq/image/upload/v1750067985/abi_sirhem.png"
          alt="happy businesswoman"
          className="w-full h-full object-cover opacity-40 grayscale"
          style={{ scaleX: -1 }} // Flip horizontally
          initial={{
            scale: 1.1,
            x: 40,
          }}
          animate={{
            scale: 1,
            x: 0,
          }}
          transition={{
            duration: 10,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "reverse",
          }}
        />
      </div>

      <LandingPage />
      <Services />
      <Approach />
      <Impact />
      <Programs />
      <Testimonial />
      <Cta />
    </div>
  )
};

export default Home;